import { Paragraph } from '../Ant';
import ClosableModal from '../closableModal/closableModal';

interface DescriptionModalProps {
  title: string;
  description?: string;
  open: boolean;
  onClose: () => void;
}

const DescriptionModal = ({ title, description, open, onClose }: DescriptionModalProps) => {
  return (
    <ClosableModal
      data-testid="description-modal"
      title={title}
      open={open}
      onClose={onClose}
      className="descriptionmodal"
      resizable
    >
      <Paragraph
        data-testid="description-paragraph"
        className="resizable-modal-scroll scroll-to-modal-edge"
        $fontsize="13px"
        $lineheight="20px"
        $color="subtitle"
      >
        {description}
      </Paragraph>
    </ClosableModal>
  );
};

export default DescriptionModal;
